
<div class="p-3 d-flex justify-content-between">
  <h2 class="mb-0" mat-dialog-title>{{data.message}}</h2>
  <button mat-button mat-dialog-close >x</button>
</div>
<mat-dialog-content class="mat-typography">
  <app-productos-details></app-productos-details>
</mat-dialog-content>
